import { render, staticRenderFns } from "./SiteGroupByGridView.vue?vue&type=template&id=3bca4652&"
import script from "./SiteGroupByGridView.vue?vue&type=script&lang=js&"
export * from "./SiteGroupByGridView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports